
import {defineComponent} from 'vue';
import MyProjetos from "@/components/SectionPortfolio/MyProjetos.vue";

export default defineComponent({
  name: 'SectionPortfolio',
  components: {MyProjetos}
});
